import { Box, FormControl, TextField, Grid, Paper, Typography, useTheme } from "@mui/material";
import { useGetIdentity, useTranslation } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { FC } from "react";

export const ClientCreate: FC<{ onClose?: () => void }> = ({ onClose }) => {
  const { translate } = useTranslation();
  const theme = useTheme();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
    setValue,
  } = useForm();

  const { data: user } = useGetIdentity<{
    name: string;
    avatar: any;
    id: any;
  }>();

  const userId = user && user.id;

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Paper elevation={0} sx={{ p: 2 }}>
        {/* <Typography variant="h6" color="primary" gutterBottom sx={{ mb: 3 }}>
          {translate("create-client")}
        </Typography> */}
        
        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
          autoComplete="off"
        >
          <FormControl sx={{ display: "none" }}>
            <TextField
              type="hidden"
              {...register("user", {
                required: translate("this-field-is-required"),
              })}
              error={!!(errors as any)?.user}
              helperText={(errors as any)?.user?.message}
              value={userId}
              InputLabelProps={{ shrink: true }}
              name="user"
            />
          </FormControl>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                {...register("name", {
                  required: translate("this-field-is-required"),
                })}
                error={!!(errors as any)?.name}
                helperText={(errors as any)?.name?.message}
                fullWidth
                InputLabelProps={{ shrink: true }}
                type="text"
                label={translate("name")}
                name="name"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                {...register("pseudo")}
                fullWidth
                InputLabelProps={{ shrink: true }}
                type="text"
                label={translate("pseudo")}
                name="pseudo"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                {...register("phone", {
                  valueAsNumber: true,
                })}
                error={!!(errors as any)?.phone}
                helperText={(errors as any)?.phone?.message}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={translate("phone")}
                name="phone"
                type="tel"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                {...register("adresse")}
                error={!!(errors as any)?.adresse}
                helperText={(errors as any)?.adresse?.message}
                fullWidth
                InputLabelProps={{ shrink: true }}
                type="text"
                label={translate("adresse")}
                name="adresse"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                {...register("color")}
                error={!!(errors as any)?.color}
                helperText={(errors as any)?.color?.message}
                fullWidth
                InputLabelProps={{ shrink: true }}
                label={"Color"}
                name="Color"
                type="color"
                onChange={(e) =>
                  setValue("color", e.target.value, {
                    shouldDirty: true,
                    shouldTouch: true,
                    shouldValidate: true,
                  })
                }
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                  '& input[type="color"]': {
                    width: '100%',
                    height: '56px',
                    padding: '6px',
                    cursor: 'pointer',
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Create>
  );
};
